import React from 'react'
import PropTypes from 'prop-types'
import { Button, Modal } from 'react-bootstrap'
import CustomButton from '../../CustomButton'

const ModalDelete = (props) => {
	const { content, deleteBtnName, closeModal, deleteModal, title, backdropClassName, showClose, styleView } = props;

	const confirmBtnName = deleteBtnName || 'DELETE';

	return (
		<Modal
			show
			onHide={closeModal}
			dialogClassName="has-error"
			backdropClassName={backdropClassName}
		>
			<Modal.Header closeButton>
				<Modal.Title className={`${styleView === 'delete' ? 'delete-title' : ''}`}>{title || 'Delete'}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="modal-text">
					{content}
				</div>
			</Modal.Body>
			<Modal.Footer className="default-modal-footer modal-footer">
				{showClose && <CustomButton variant="primary-outline" onClick={closeModal}>Cancel</CustomButton >}
				<CustomButton variant={`${styleView === 'delete' ? 'delete' : 'primary'}`} onClick={deleteModal}>{confirmBtnName}</CustomButton >
			</Modal.Footer>
		</Modal>
	)
}

ModalDelete.propTypes = {
	backdropClassName: PropTypes.string,
	showClose: PropTypes.bool,
	styleView: PropTypes.string,
}

ModalDelete.defaultProps = {
	backdropClassName: 'custom-modal-backdrop',
	showClose: false,
	styleView: 'delete',
}

export default ModalDelete;
